import { render, staticRenderFns } from "./WeekCalendar.vue?vue&type=template&id=0f921d2a&scoped=true"
import script from "./WeekCalendar.vue?vue&type=script&lang=js"
export * from "./WeekCalendar.vue?vue&type=script&lang=js"
import style0 from "./WeekCalendar.vue?vue&type=style&index=0&id=0f921d2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f921d2a",
  null
  
)

export default component.exports